import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from './store'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css';
import "./assets/css/bootstrap.min.css"
import "./assets/css/main.scss"


const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus)
app.use(Vant)
app.use(store)
app.use(router)

app.mount('#app')
